import { render, staticRenderFns } from "./NoProject.vue?vue&type=template&id=407f550b&"
import script from "./NoProject.vue?vue&type=script&lang=js&"
export * from "./NoProject.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ganttpro/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('407f550b')) {
      api.createRecord('407f550b', component.options)
    } else {
      api.reload('407f550b', component.options)
    }
    module.hot.accept("./NoProject.vue?vue&type=template&id=407f550b&", function () {
      api.rerender('407f550b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "public/views/newProject/NoProject.vue"
export default component.exports